import React, { useState } from 'react';
import { IconButton, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { useSearchParams } from 'react-router-dom';

import PropTypes from 'prop-types';

SearchField.propTypes = {
    helperText: PropTypes.string
};

export default function SearchField({helperText}) {
    const [searchParams, setSearchParams] = useSearchParams();
    const [value, setValue] = useState(searchParams.get('search') || '');

    const handleInputChange = (event) => {
        setValue(event.target.value);
    };

    const handleInputSubmit = (val) => {
        setSearchParams({ ...Object.fromEntries(searchParams), search: val });
    };

    return (
        <TextField
            value={value}
            onChange={handleInputChange}
            onBlur={() => handleInputSubmit(value)}
            onKeyDown={(event) => {
                if (event.key === 'Enter') {
                    handleInputSubmit(value);
                }
            }}
            placeholder="Buscar"
            variant="standard"
            fullWidth
            helperText={helperText}
            slotProps={{
                input: {
                    startAdornment: (
                        <IconButton size="small" edge="start">
                            <SearchIcon color="info" />
                        </IconButton>
                    ),
                    endAdornment: value && (
                        <IconButton
                            size="small"
                            edge="end"
                            onClick={() => {
                                setValue('');
                                handleInputSubmit('');
                            }}
                            color="info"
                        >
                            <ClearIcon />
                        </IconButton>
                    ),
                },
            }}
        />
    );
}